import {observer} from "@legendapp/state/react";
import {CellProps} from "react-table";
import {ClientOnline} from "_types/responses/Ws/desk/desk-client-online";
import {$currentTime, diff2human} from "_utils/time";

export const TimeOnQueueCell = observer(({value, row: {original: clientOnline}}: CellProps<ClientOnline>) => {
    return (
        <>{diff2human($currentTime.get(), clientOnline.queueInfo.enteredAt)}</>
    )
})
